import * as React from 'react';
import { Box, IconButton, Stack } from '@mui/material';
import { IUserSettingsProps } from './types';
import { theme } from '../../../../../common/styles/theme';
import { ButtonIconGrey } from '../../../../../common/components/ButtonIconGrey/ButtonIconGrey';
import { PhraseTranslationSettingsHOC } from '../../PhraseDetailsTabsEditor/PhraseDetailsTabTranslation/PhraseTranslationSettings/hocs/PhraseTranslationSettingsHOC';
import { Modal } from '../../../../../common/components/Modal/Modal';
import { Paper } from '../../../../../common/components/Paper/Paper';
import { ArrowLightLeftIcon } from '../../../../../../icons/ArrowLightLeftIcon';
import { Logo } from '../../../../../../icons/Logo';
import { DeviceContext } from '../../../../../common/contexts/DeviceContext';
import { PlaybackSettingsHOC } from '../../CaptionsContainer/PlaybackSettings/hocs/PlaybackSettingsHOC';

export const UserSettings: React.FC<IUserSettingsProps> = ({
	onLoad,
	onClose,
}) => {
	const { isMobile } = React.useContext(DeviceContext);

	React.useEffect(() => {
		onLoad();
	});

	return (<Modal
		open={true}
		onClose={onClose}
		PaperProps={{
			sx: {
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				maxHeight: '100% !important',
				background: theme.palette.common.white,
				borderRadius: 0,

				'& > .MuiStack-root': {
					gap: `0 !important`,
					p: `0 !important`,
					maxHeight: `100% !important`,
				},
			},
		}}
	>
		<Stack
			sx={{
				position: 'relative',
				height: 1,
			}}
		>
			<Paper
				sx={{
					position: 'sticky',
					top: 0,
					zIndex: 100,
					flex: `0 0 ${theme.spacing(8)}`,
					py: 1.5,
					px: 2,
					borderRadius: 0,
					boxShadow: theme.shadows[8],

					'.mobile &': {
						p: 1,
					}
				}}
			>
				<Stack
					direction={'row'}
					alignItems={'center'}
					gap={theme.spacing(1)}
					sx={{
						width: 1,
						height: 1,
					}}
				>
					<ButtonIconGrey
						sx={{
							'.MuiSvgIcon-root': {
								width: theme.spacing(3),
								height: theme.spacing(3),
							},
						}}
						onClick={onClose}
					>
						<ArrowLightLeftIcon />
					</ButtonIconGrey>

					<IconButton
						sx={{
							p: 0,
						}}
						onClick={onClose}
					>
						<Logo sx={{ height: theme.spacing(4), width: 'auto' }} />
					</IconButton>

					{!isMobile &&
						<Stack
							direction={'row'}
							alignItems={'center'}
							gap={theme.spacing(1)}
							sx={{
								ml: theme.spacing(2),
								fontSize: theme.typography.h4,
								fontWeight: 600,
								whiteSpace: 'nowrap',
							}}
						>
							Settings
						</Stack>
					}
				</Stack>
			</Paper>

			<Box
				sx={{
					flex: `1 1 100%`,
					minHeight: 0,
					width: 1,
					p: 2,

					overflow: 'hidden auto',
				}}
			>
				<Stack
					flexDirection={'row'}
					gap={5}
					sx={{
						'.phrase-translation-settings': {
							p: 0,
						},

						'@media (max-width: 720px)': {
							flexDirection: 'column',
						}
					}}
				>
					<PlaybackSettingsHOC isInline />

					<PhraseTranslationSettingsHOC />

				</Stack>
			</Box>
		</Stack>
	</Modal>);
};
